import { Component, Input, OnInit } from '@angular/core';
import { texts } from './candidate-skills.texts';

@Component({
  standalone: false,
  selector: 'app-candidate-skills',
  templateUrl: './candidate-skills.component.html',
  styleUrls: ['./candidate-skills.component.scss']
})
export class CandidateSkillsComponent implements OnInit {

  texts = texts;

  @Input()
  candidate : any;

  @Input()
  assignment : any;

  constructor() { }

  ngOnInit(): void {
  }

}
